import React from 'react';
import Layout from '../../components/Layout';
import TdsReportContent from '../../components/admin/TdsReportContent';
import { FileText } from 'lucide-react';

const TdsReport = () => {
    return (
        <Layout>
            <div className="space-y-10 p-2 sm:p-4 animate-fadeIn">
                <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-6">
                    <div className="flex items-center gap-6">
                        <div className="p-4 bg-red-600 rounded-[2rem] shadow-xl shadow-red-100 ring-4 ring-red-50">
                            <FileText className="text-white" size={32} strokeWidth={2.5} />
                        </div>
                        <div>
                            <h1 className="text-4xl sm:text-5xl font-black text-slate-900 tracking-tighter leading-none mb-2">
                                TDS Master <span className="text-red-600">Report</span>
                            </h1>
                            <div className="flex items-center gap-2">
                                <span className="px-3 py-1 bg-slate-100 text-slate-500 rounded-full text-[10px] font-black uppercase tracking-widest">Administrator</span>
                                <div className="h-1.5 w-1.5 rounded-full bg-red-600 animate-pulse" />
                                <span className="text-slate-400 text-[10px] font-bold uppercase tracking-widest">Financial Audit Logs</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="bg-slate-50/50 rounded-[3rem] p-1 border-2 border-slate-100 shadow-inner">
                    <div className="bg-white rounded-[2.8rem] p-6 sm:p-8 shadow-2xl shadow-slate-200 border border-slate-50 transition-all duration-500 hover:shadow-red-500/5">
                        <TdsReportContent />
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default TdsReport;
